import {
    instance
} from '../../util/http'
import apis from '../../config/apis'

const post = (data) => {
    return instance.post(apis.Setting.SettingPhone, data)
}
const shareCode = (data) => {
    return instance.post(apis.Setting.SettingCode,data)
}
// 发送短信验证
const code = (data) => {
    return instance.post(apis.Setting.Sms, data)
}
// 获取短信验证
const get = (data) => {
    return instance.post(apis.Setting.Sms, data)
}
// 获取商品码弹框数量
const codeNum = (data) => {
    return instance.get(apis.Setting.CodeNum, data)
}
// 换绑微信号
const wxCode = (data) => {
    return instance.post(apis.Setting.WXCode, data)
}

// 
const IDCard = (data) => {
    return instance.post(apis.Setting.IDCard, data)
}

// 获取用户信息
const getUserInfo = (data) => {
    return instance.get(apis.Setting.GetUserInfo, data)
}

// 修改用户名
const updateUserName = (data) => {
    return instance.post(apis.Setting.UpdateUserName + "?userName=" + data )
}

// 修改头像
const UploadUserImage = (data) => {
    return instance.post(apis.Setting.UploadUserImage,data,  {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export default {
    post,
    shareCode,
    code,
    get,
    codeNum,
    wxCode,
    IDCard,
    getUserInfo,
    updateUserName,
    UploadUserImage
}